var _ellipse, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewContent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 76,
    viewBox: "0 0 82 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.0465,
    cy: 50.1828,
    rx: 25.2496,
    ry: 25.0191,
    fill: "#e5e3f8",
    fillOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.625 59.375C72.625 64.5527 68.4277 68.75 63.25 68.75H25.75C20.5723 68.75 16.375 64.5527 16.375 59.375V15.625C16.375 10.4473 20.5723 6.25 25.75 6.25H56.2417C56.4957 6.25 56.7487 6.26031 57 6.28069C57.0562 6.28525 57.1123 6.29031 57.1684 6.29587C59.3145 6.50897 61.3325 7.45749 62.8709 8.99587L69.8791 16.0041C71.4577 17.5827 72.4152 19.6662 72.5943 21.875C72.5944 21.8765 72.5945 21.8779 72.5947 21.8794C72.6148 22.1293 72.625 22.3807 72.625 22.6333V59.375ZM63.25 65.625H25.75C22.2982 65.625 19.5 62.8268 19.5 59.375V15.625C19.5 12.1732 22.2982 9.375 25.75 9.375H53.875V15.625C53.875 20.8027 58.0723 25 63.25 25H69.5V59.375C69.5 62.8268 66.7018 65.625 63.25 65.625ZM69.4538 21.8749C69.2854 20.4968 68.6614 19.2058 67.6694 18.2138L60.6612 11.2056C59.7088 10.2532 58.4808 9.63999 57.1647 9.44349C57.1099 9.43532 57.055 9.42787 57 9.42114V15.625C57 19.0768 59.7982 21.875 63.25 21.875L69.4538 21.8749C69.4538 21.8749 69.4538 21.875 69.4538 21.8749Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4375 34.375C30.4375 33.5121 31.1371 32.8125 32 32.8125H57C57.8629 32.8125 58.5625 33.5121 58.5625 34.375C58.5625 35.2379 57.8629 35.9375 57 35.9375H32C31.1371 35.9375 30.4375 35.2379 30.4375 34.375Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4375 46.875C30.4375 46.0121 31.1371 45.3125 32 45.3125H44.5C45.3629 45.3125 46.0625 46.0121 46.0625 46.875C46.0625 47.7379 45.3629 48.4375 44.5 48.4375H32C31.1371 48.4375 30.4375 47.7379 30.4375 46.875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewContent);
export default __webpack_public_path__ + "static/media/new-content.3058aaeabeacd37041c482e2ad31ab91.svg";
export { ForwardRef as ReactComponent };